import React from "react";
import {
  IcoHome, IcoFolder, IcoTrash, IcoCompress, IcoLogOut, IcoX, IcoLock,
} from "./Icons";

const initialsOf = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Thanh bên: thương hiệu, lối tắt tới các thư mục gốc, công cụ quản trị và
// thông tin người đang đăng nhập. Trên màn hình hẹp nó trượt ra như ngăn kéo.
export default function Sidebar({
  role, userName, username,
  path, rootFolders, lockedFolders = [],
  onGoTo, onOpenTrash, onCompressAll, compressing,
  onLogout, open, onClose,
}) {
  const current = path ? path.split("/")[0] : "";
  const go = (p) => { onGoTo(p); onClose(); };

  return (
    <>
      <div className={`sidebar-scrim ${open ? "show" : ""}`} onClick={onClose} />

      <aside className={`sidebar ${open ? "open" : ""}`} aria-label="Điều hướng kho ảnh">
        <div className="brand">
          <span className="brand-mark">
            <img src="/logo.png" alt="" />
          </span>
          <span className="brand-text">
            <strong>Ảnh Nội Bộ</strong>
            <span>Bệnh viện Hùng Vương Gia Lai</span>
          </span>
          <button className="icon-btn ghost sidebar-close" onClick={onClose} aria-label="Đóng trình đơn">
            <IcoX size={18} />
          </button>
        </div>

        <nav className="side-nav">
          <div className="side-label">Kho ảnh</div>
          <button
            className={`side-item ${path === "" ? "active" : ""}`}
            onClick={() => go("")}
          >
            <IcoHome size={17} />
            <span>Tất cả thư mục</span>
          </button>

          <div className="side-folders">
            {rootFolders.map((f) => (
              <button
                key={f}
                className={`side-item ${current === f ? "active" : ""}`}
                onClick={() => go(f)}
                title={f}
              >
                <IcoFolder size={17} />
                <span>{f}</span>
                {lockedFolders.includes(f) && (
                  <IcoLock size={13} className="side-lock" aria-label="Có mật khẩu" />
                )}
              </button>
            ))}
          </div>

          {role === "admin" && (
            <>
              <div className="side-label">Quản trị</div>
              <button className="side-item" onClick={() => { onOpenTrash(); onClose(); }}>
                <IcoTrash size={17} />
                <span>Thùng rác</span>
              </button>
              <button
                className="side-item"
                onClick={() => { onCompressAll(); onClose(); }}
                disabled={compressing}
                title="Nén mọi ảnh JPG/PNG trên 5 MB trong toàn bộ kho"
              >
                <IcoCompress size={17} />
                <span>{compressing ? "Đang nén ảnh…" : "Nén toàn bộ ảnh"}</span>
              </button>
            </>
          )}
        </nav>

        <div className="side-user">
          <span className="avatar" aria-hidden="true">{initialsOf(userName || username)}</span>
          <span className="side-user-text">
            <strong title={userName}>{userName || username || "Người dùng"}</strong>
            <span>{role === "admin" ? "Quản trị viên" : "Nhân viên"}</span>
          </span>
          <button className="icon-btn ghost" onClick={onLogout} title="Đăng xuất" aria-label="Đăng xuất">
            <IcoLogOut size={18} />
          </button>
        </div>
      </aside>
    </>
  );
}
